/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'trash': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="currentColor" fill-rule="nonzero"><path pid="0" d="M6.5 12.683h.05c.4-.033.717-.383.683-.783l-.466-6.7a.753.753 0 00-.784-.683c-.4.033-.716.383-.683.783l.467 6.7c.033.383.35.683.733.683zM9.45 12.667h.05c.383 0 .7-.3.733-.684l.467-6.7c.033-.4-.283-.75-.683-.783a.753.753 0 00-.784.683l-.466 6.7a.711.711 0 00.683.784z"/><path pid="1" d="M15.183 1.567h-4.25l-.783-1.1A.782.782 0 009.533.15H6.467a.736.736 0 00-.617.317l-.783 1.1H.817a.74.74 0 00-.734.733c0 .4.334.733.734.733h.633l1.267 10.584a2.162 2.162 0 002.15 1.9h6.283c1.1 0 2.017-.817 2.15-1.9l1.267-10.584h.633a.74.74 0 00.733-.733.766.766 0 00-.75-.733zm-3.35 11.866a.687.687 0 01-.683.617H4.867a.687.687 0 01-.684-.617l-1.25-10.4h10.15l-1.25 10.4z"/></g>'
  }
})
